import type { OperationContext, OperationResult } from "urql"
import { useMutation } from "urql"

import type { Mutation, PaymentTermMutationCreateArgs, PaymentTermMutationUpdateArgs } from "@/graphql/codegen/graphql"
import { AddPaymentTermsMutationDocument, UpdatePaymentTermsMutationDocument } from "@/graphql/codegen/graphql"

export const usePaymentTermMutation = (): {
  createPaymentTerm: (
    variables: PaymentTermMutationCreateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "paymentTerm">, PaymentTermMutationCreateArgs>>
  updatePaymentTerm: (
    variables: PaymentTermMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "paymentTerm">, PaymentTermMutationUpdateArgs>>
} => {
  const [, createPaymentTerm] = useMutation<Pick<Mutation, "paymentTerm">, PaymentTermMutationCreateArgs>(
    AddPaymentTermsMutationDocument
  )

  const [, updatePaymentTerm] = useMutation<Pick<Mutation, "paymentTerm">, PaymentTermMutationUpdateArgs>(
    UpdatePaymentTermsMutationDocument
  )

  return {
    createPaymentTerm,
    updatePaymentTerm,
  }
}
